<template>
  <div>
    <b-field :label="$t('title')">
      <b-select v-model="formData.title" :placeholder="$t('nA')">
        <option value="ms">
          {{ $t("ms") }}
        </option>
        <option value="mr">
          {{ $t("mr") }}
        </option>
        <option :value="null">
          {{ $t("nA") }}
        </option>
      </b-select>
    </b-field>
    <b-field :label="$t('firstName')">
      <b-input v-model="formData.firstName" required />
    </b-field>
    <b-field :label="$t('lastName')">
      <b-input v-model="formData.lastName" required />
    </b-field>
    <b-field :label="$t('telephoneNumber')" />
    <PhoneNumberPicker v-model="formData.telephoneNumber" :required="formData.mobileNumber ? false : true" />
    <b-field :label="$t('mobileNumber')" />
    <PhoneNumberPicker v-model="formData.mobileNumber" :required="formData.telephoneNumber ? false : true" />
    <b-field class="mt-4" :grouped="true" :group-multiline="true">
      <b-button
        class="control"
        type="is-primary"
        icon-left="content-save-outline"
        :loading="isLoading"
        @click="saveSettings"
      >
        {{ $t("saveSettings") }}
      </b-button>
    </b-field>
    <slot />
  </div>
</template>

<script>
import { functions } from "@/firebase";
import PhoneNumberPicker from "@/components/PhoneNumberPicker";

export default {
  name: "UserSettings",
  components: {
    PhoneNumberPicker,
  },
  props: {
    user: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      isLoading: false,
      formData: {
        title: null,
        firstName: "",
        lastName: "",
        telephoneNumber: "",
        mobileNumber: "",
      },
    };
  },
  watch: {
    user: {
      immediate: true,
      handler() {
        if (this.user) {
          this.formData.firstName = this.user.firstName;
          this.formData.lastName = this.user.lastName;
          this.formData.title = this.user.title;
          this.formData.telephoneNumber = this.user.telephoneNumber;
          this.formData.mobileNumber = this.user.mobileNumber;
        }
      },
    },
  },
  methods: {
    async saveSettings() {
      this.isLoading = true;
      await functions
        .httpsCallable("SetUserInformation")({
          title: this.formData.title,
          firstName: this.formData.firstName,
          lastName: this.formData.lastName,
          telephoneNumber: this.formData.telephoneNumber,
          mobileNumber: this.formData.mobileNumber,
        })
        .then(() => {
          this.$buefy.toast.open({
            message: this.$t("settingsSaved"),
            type: "is-success",
          });
        })
        .catch((err) => {
          this.$buefy.toast.open({
            message: err,
            type: "is-danger",
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>

<style scoped></style>
